"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _materialSymbols = require("@design/icons/material-symbols");
var _dioptraLogo = _interopRequireDefault(require("@assets/dioptra-logo.svg"));
var _dioptraIcon = _interopRequireDefault(require("@assets/dioptra-icon.svg"));
var _loginBg = _interopRequireDefault(require("@assets/login-bg.jpg"));
var _IcertisMarkIcon = _interopRequireDefault(require("../common/IcertisMarkIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var PageContainer = _styledComponents.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n    overflow-y: auto;\n    box-sizing: border-box;\n    background-color: white;\n    background-image: url(", ");\n    background-size: cover;\n    background-position: center;\n"])), function (_ref) {
  var $bg = _ref.$bg;
  return $bg;
});
var TopSection = _styledComponents.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 60px;\n    margin-bottom: 72px;\n    width: 100%;\n"])));
var LogoRow = _styledComponents.styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 4px;\n"])));
var FlameIcon = _styledComponents.styled.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 48px;\n    height: 48px;\n    object-fit: contain;\n"])));
var DioptraWordmark = _styledComponents.styled.img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    height: 18px;\n    object-fit: contain;\n"])));
var IcertisCaption = _styledComponents.styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-size: 10px;\n    font-weight: 600;\n    color: #6b7280;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    margin: 0;\n"])));
var MiddleSection = _styledComponents.styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    flex: 0.7;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 600px;\n    padding: 0 40px 24px;\n    box-sizing: border-box;\n"])));
var Heading = _styledComponents.styled.h1(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    font-size: clamp(24px, 5.5vh, 40px);\n    font-weight: 600;\n    color: #0f172a;\n    text-align: center;\n    margin: 0 0 48px;\n    line-height: clamp(34px, 8vh, 60px);\n    letter-spacing: -0.02em;\n"])));
var CardsWrapper = _styledComponents.styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n"])));
var OptionCard = _styledComponents.styled.button(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 72px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 12px;\n    background: white;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 12px;\n    cursor: pointer;\n    text-align: left;\n    box-sizing: border-box;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    transition: box-shadow 0.15s ease, border-color 0.15s ease;\n\n    &:hover {\n        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n        border-color: rgba(66, 91, 206, 0.35);\n    }\n"])));
var CardIconWrapper = _styledComponents.styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n    width: 44px;\n    height: 44px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f3f4f6;\n    border-radius: 10px;\n\n    img {\n        width: 28px;\n        height: 28px;\n        object-fit: contain;\n    }\n"])));
var CardTitle = _styledComponents.styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    flex: 1;\n    font-size: 13px;\n    font-weight: 600;\n    color: #0f172a;\n    line-height: 1;\n    letter-spacing: 0;\n    text-align: center;\n"])));
var LoginSelectionScreen = function LoginSelectionScreen(_ref2) {
  var onIcertisSelect = _ref2.onIcertisSelect,
    onDioptraLogin = _ref2.onDioptraLogin;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(PageContainer, {
    $bg: _loginBg.default,
    "data-sentry-element": "PageContainer",
    "data-sentry-component": "LoginSelectionScreen",
    "data-sentry-source-file": "LoginSelectionScreen.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(TopSection, {
      "data-sentry-element": "TopSection",
      "data-sentry-source-file": "LoginSelectionScreen.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(LogoRow, {
        "data-sentry-element": "LogoRow",
        "data-sentry-source-file": "LoginSelectionScreen.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(FlameIcon, {
          src: _dioptraIcon.default,
          alt: "Dioptra",
          "data-sentry-element": "FlameIcon",
          "data-sentry-source-file": "LoginSelectionScreen.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DioptraWordmark, {
          src: _dioptraLogo.default,
          alt: "Dioptra",
          "data-sentry-element": "DioptraWordmark",
          "data-sentry-source-file": "LoginSelectionScreen.tsx"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(IcertisCaption, {
        "data-sentry-element": "IcertisCaption",
        "data-sentry-source-file": "LoginSelectionScreen.tsx",
        children: "An Icertis Company"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(MiddleSection, {
      "data-sentry-element": "MiddleSection",
      "data-sentry-source-file": "LoginSelectionScreen.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Heading, {
        "data-sentry-element": "Heading",
        "data-sentry-source-file": "LoginSelectionScreen.tsx",
        children: "Review your Contracts with Dioptra Agent"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(CardsWrapper, {
        "data-sentry-element": "CardsWrapper",
        "data-sentry-source-file": "LoginSelectionScreen.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(OptionCard, {
          onClick: onIcertisSelect,
          "data-sentry-element": "OptionCard",
          "data-sentry-source-file": "LoginSelectionScreen.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CardIconWrapper, {
            "data-sentry-element": "CardIconWrapper",
            "data-sentry-source-file": "LoginSelectionScreen.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IcertisMarkIcon.default, {
              size: 32,
              "data-sentry-element": "IcertisMarkIcon",
              "data-sentry-source-file": "LoginSelectionScreen.tsx"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CardTitle, {
            "data-sentry-element": "CardTitle",
            "data-sentry-source-file": "LoginSelectionScreen.tsx",
            children: "Icertis"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
            width: 18,
            height: 18,
            color: "#9CA3AF",
            "data-sentry-element": "ChevronRightIcon",
            "data-sentry-source-file": "LoginSelectionScreen.tsx"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(OptionCard, {
          onClick: onDioptraLogin,
          "data-sentry-element": "OptionCard",
          "data-sentry-source-file": "LoginSelectionScreen.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CardIconWrapper, {
            "data-sentry-element": "CardIconWrapper",
            "data-sentry-source-file": "LoginSelectionScreen.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(FlameIcon, {
              src: _dioptraIcon.default,
              alt: "",
              "data-sentry-element": "FlameIcon",
              "data-sentry-source-file": "LoginSelectionScreen.tsx"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CardTitle, {
            "data-sentry-element": "CardTitle",
            "data-sentry-source-file": "LoginSelectionScreen.tsx",
            children: "Dioptra"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
            width: 18,
            height: 18,
            color: "#9CA3AF",
            "data-sentry-element": "ChevronRightIcon",
            "data-sentry-source-file": "LoginSelectionScreen.tsx"
          })]
        })]
      })]
    })]
  });
};
var _default = exports.default = LoginSelectionScreen;